export default [{
  name: 'Coge Consultar',
  path: '/coge',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Coge',
      path: 'consultar',
      component: () => import('@/views/coge/Consultar.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'COGE' }
        ]
      }
    }
  ]
}]